// Robust function to generate a unique key for any recommendation
export const getRecommendationKey = (recommendation) => {
    // Create a stable string representation of the recommendation
    const keyParts = [
      recommendation.Title,
      ...recommendation.data.map(item => `${item.label}:${item.value}`),
      recommendation.isRecommended ? 'recommended' : ''
    ];
    return keyParts.join('|');
  };
  